import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class PermissionService {
    private _permissions = new Set<string>();

    loadPermissions(list: string[]) {
        this._permissions = new Set(list);
    }

    has(permission: string) {
        return this._permissions.has(permission);
    }

    hasAny(permissions: string[]) {
        return permissions.some(p => this.has(p));
    }
}
